/**
 * React bindings for the session store.
 *
 * `useSyncExternalStore` is used instead of a context + useState pair so that the
 * store stays the single source of truth and no effect is needed to keep React in
 * sync with session changes made by the transport layer (for example a 401).
 */

import { useSyncExternalStore } from 'react';

import { sessionStore, type SessionSnapshot } from './session';

export function useSession(): SessionSnapshot {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.getSnapshot);
}

export { sessionStore };
export type { SessionSnapshot };
